import styled from 'styled-components';

import { CustomCss } from '@utils/types';
export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
`;
// Hide checkbox visually but remain accessible to screen readers.
// Source: https://polished.js.org/docs/#hidevisually
export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
  height: 1px;
`;

type LabelProps = {
  customCss?: CustomCss;
};
export const Label = styled.span<LabelProps>`
  padding: 0 8px;
  ${(props) => props.customCss}
  flex: 1;
  display: inline-flex;
  user-select: none;
`;
